<template>
  <div class="footer" :style="{ borderTopColor: background }">
    <div class="foot-nav">
      <router-link to="">首页</router-link>&nbsp;|&nbsp;
      <router-link to="">中心介绍</router-link>&nbsp;|&nbsp;
      <router-link to="">收费公示</router-link>&nbsp;|&nbsp;
      <router-link to="">新闻中心</router-link>&nbsp;|&nbsp;
      <router-link to="">科研管理</router-link>&nbsp;|&nbsp;
      <router-link to="">合作交流</router-link>&nbsp;|&nbsp;
      <router-link to="">在线服务</router-link>&nbsp;|&nbsp;
      <router-link to="">人力资源</router-link>&nbsp;|&nbsp;
      <router-link to="">文化组织</router-link>&nbsp;|&nbsp;
      <router-link to="">联系我们</router-link>
    </div>
    <p class="mgt-10">
      版权所有：江苏省产品质量监督检验研究院 地址：南京市光华东街5号
    </p>
    <p class="mgt-10">技术支持：辰星科技</p>
    <p class="mgt-10 flex flex-center justify-center">
      <img
        src="~@/assets/images/icp.png"
        style="margin-right: 5px"
      />ICP备案号：苏ICP备12068564号 邮编：210007
    </p>
  </div>
</template>
<script>
export default {
  props: {
    background: {
      type: String,
      default: "#2ca1c9",
    },
  },
};
</script>
<style lang="less" scoped>
.footer {
  margin-top: 20px;
  border-top: 3px solid #2ca1c9;
  padding: 48px 0 80px;
  text-align: center;
  color: #666666;
  font-size: 14px;
}
</style>